import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Clickable from '../../../components/clickable/Clickable';
import styles from '../fields.module.scss';


class RiskAssessmentMatrix extends Component {
  constructor(props) {
    super(props);
    const { isRequired, answer, updateFieldErrors } = this.props;
    this.state = {
      showMatrix: false
    };

    if (isRequired && !answer) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  handleMatrix = (e) => {
    const {
      fieldId, riskMatrix, riskLevels
    } = this.props;
    const riskValue = e.target.dataset.value?.split('');
    this.handleAnswerChanged(
      {
        value: e.target.dataset.value,
        risk_levels: riskLevels?.filter(level => (
          riskMatrix?.values?.[riskValue[0]][riskValue[1]].indexOf(level.id) !== -1
        ))?.map(level => ({ color: level.color, description: level.description }))
      },
      fieldId
    );
    this.setState({
      showMatrix: false
    });
  }

  handleDisplayMatrix = () => {
    const { showMatrix } = this.state;
    this.setState({
      showMatrix: !showMatrix
    });
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors
    } = this.props;
    handleValueChange(value, fieldId);
    let updatedErrors = [];

    if (value === '' || value === undefined || value?.value?.trim() === '') {
      handleFieldErrorChanged(fieldId, isRequired);
      if (isRequired) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      }
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const {
      disabled
    } = this.props;
    return (
      <>
          {disabled && (
            <Clickable onClick={() => this.handleDisplayMatrix()}>
              <span className={styles.matrix}>
                <FormattedMessage id="pulpofield.risk_assess" defaultMessage="Submit Risk Assessment" />
              </span>
            </Clickable>
          )}
      </>
    );
  }
}


RiskAssessmentMatrix.defaultProps = {
  answer: ''
};

RiskAssessmentMatrix.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  riskMatrix: state.sms?.riskMatrix?.risk_matrix,
  riskLevels: state.sms?.riskMatrix?.risk_levels || []
});


export default connect(
  mapStateToProps
)(RiskAssessmentMatrix);
